










































import {
  SfList,
} from '@storefront-ui/vue'
import DsbOrderListItem from '~/modules/customer/components/Orders/DsbOrderListItem.vue'
import DsbConfirmationModal from "~/components/Modal/DsbConfirmationModal.vue";
import DsbNotification from '~/components/DsbNotification.vue'
import useOrderCancellation from "~/modules/customer/composables/useOrderCancellation";
import {computed, ref} from "@nuxtjs/composition-api";
import {ProductDetailType} from "~/types/ProductData";

export default {
  name: 'CancelOrderItemModal',
  components: {
    DsbOrderListItem,
    SfList,
    DsbConfirmationModal,
    DsbNotification
  },
  props: {
    orderItem: {
      type: Object,
      default: {}
    },
    showModal: {
      type: Boolean,
      default: false
    },
  },
  emits: ['close'],
  setup(props, {emit}) {
    const {cancelOrderItem} = useOrderCancellation()

    const modal = ref({
      title: "Möchten Sie diese Bestellposition wirklich stornieren?",
      subline: "",
      agreeButtonText: "Stornierung bestätigen",
      cancelButtonText: "Stornierung abbrechen",
    })

    const isVisibleNotification = ref(false)

    const notification = ref({
      title: '',
      message: '',
      notificationType: '',
    })

    const confirmHandler = async () => {
      const result = await cancelOrderItem(previewItem.value.orderItemId)

      if (result.requestOrderItemCancellation.success) {
        notification.value = {
          title: '',
          message: result.requestOrderItemCancellation.message,
          notificationType: 'success',
        }
      } else {
        notification.value = {
          title: 'Es ist ein Fehler aufgetreten!',
          message: result.requestOrderItemCancellation.message,
          notificationType: 'error',
        }
      }

      isVisibleNotification.value = true
      props.showModal = false
    }

    const closeHandler = () => {
      emit('close', false)
    }

    const isModalVisible = computed(() => {
      return props.showModal
    })

    const previewItem = computed(() => {
      return props.orderItem
    })


    return {
      modal,
      isVisibleNotification,
      notification,
      isModalVisible,
      closeHandler,
      confirmHandler,
      previewItem,
      ProductDetailType
    }
  },
}
